import {
  GridColDef,
  GridColumnVisibilityModel,
  GridRowSelectionModel,
} from '@mui/x-data-grid-pro'
import React from 'react'
import { chevronColumnDef } from 'src/components/DataGrid/cells/ChevronCell'
import DataGrid, { DataGridRowHeight } from 'src/components/DataGrid/DataGrid'
import { useBackgroundDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { connectedPush } from 'src/navigation/Lnk'
import { departmentDetailsUrl } from 'src/navigation/urls'
import { DepartmentResponse } from 'src/queries/organizations/department.queries'

type DepartmentsDataGridProps = {
  departments: DepartmentResponse[]
  organizationId: string
  defaultColumnVisibilityModel: GridColumnVisibilityModel
  rowSelectionModel?: GridRowSelectionModel
  clearRowSelection?: boolean
  clientHeight?: number
}

const DepartmentsDataGrid: React.FC<DepartmentsDataGridProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const dispatch = useBackgroundDispatch()

  const columns: Array<GridColDef<DepartmentResponse>> = [
    {
      field: 'name',
      headerName: translate('Team'),
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: 'description',
      headerName: translate('Description'),
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: 'code',
      headerName: translate('Team Code'),
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: 'size',
      headerName: translate('Team Size'),
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    chevronColumnDef,
  ]
  return (
    <DataGrid
      height={props.clientHeight}
      rows={props.departments}
      columns={columns}
      filtersBody={{}}
      rowHeight={DataGridRowHeight.Default}
      disableColumnFilter
      onRowClick={(row): void => {
        dispatch(
          connectedPush({
            pathname: departmentDetailsUrl(
              props.organizationId,
              row.id.toString(),
            ),
            search: '',
            hash: '',
            state: {},
          }),
        )
      }}
    />
  )
}

export default DepartmentsDataGrid
